import { Box, Fab, styled } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { Stack } from "@mui/system";
import { normalizeUnits } from "moment";

export const ContentBox = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  minHeight: 0,
}));

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FFFFFF",
    color: "#475259",
    boxShadow:
      "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);",
    minWidth: "16px",
    padding: "10px",
    borderRadius: "8px",
    fontWeight: "normal",
  },
}));

export const CardTopSection = styled(Box)(() => ({
  background: "#f8f9fa",
  padding: "10px 12px",
  textAlign: "left",
  color: "#333",
  fontWeight: 600,
  fontSize: "14px",
  borderBottom: "1px solid #e9ecef",
}));
export const CardBottomSection = styled(Box)(() => ({
  background: "#4361ee",
  padding: "4px 8px",
  textAlign: "center",
  color: "white",
  cursor: "pointer",
  fontSize: "13px",
}));

export const CardContentSection = styled(Box)(({ contentheight }) => ({
  height: contentheight || undefined,
  flex: contentheight ? undefined : 1,
  minHeight: 0,
  overflow: "auto",
  padding: "3px",
}));

export const CardListStack = styled(Box)(({ selectedstep }) => ({
  borderBottom: "1px solid #f0f0f0",
  color: selectedstep == 1 ? "#4361ee" : "#555",
  fontWeight: selectedstep == 1 ? 600 : 400,
  fontSize: "13px",
  ":hover": { color: "#4361ee", cursor: "pointer", background: "#f8f9fa" },
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  padding: "8px 4px",
  borderRadius: "4px",
}));

export const RightFabButton = styled(Fab)(({ rightpos }) => ({
  right: rightpos,
  marginTop: "5.5rem",
  position: "fixed",
  borderRadius: "30px",
  borderTopRightRadius: "0px",
  borderBottomRightRadius: "0px",
  textTransform: "none",
  fontWeight: "normal",
  transition: "right 1s",
  "&:hover": {
    backgroundColor: "#1976D2",
    color: "white",
    right: "0px",
  },
}));
